export default __webpack_public_path__ + "static/media/7.177648ac.jpg";